import Clipboard from 'clipboard'
import { getRequestSign } from '../../../frontend-lib/tools/platformSign'
import { getPlatform } from '../../../frontend-lib/tools/getPlatform'
import axios from 'axios'

const platform = getPlatform()
let $platform = 'm'
if (platform.isAndroid) {
  $platform = 'android'
} else if (platform.isiPhone || platform.isiPad) {
  $platform = 'ios'
} else if (platform.isPc) {
  $platform = 'pc'
}
const UA = navigator.userAgent
const IS_IOS = /(iPhone|iPad|iPod|iOS)/i.test(UA)
const IS_Safari = /Safari/.test(UA) && !/Chrome/.test(UA)

const yiapiHost = getRunTime('//yiapi.xinli001.com')

function getRunTime(str) {
  let result
  let _href = location.href.split('.')[0]
  _href.replace(/-((box|qc)[0-9]*)/, (s, v) => {
    result = str.replace(/\./, `-${v}.`)
  })

  if (!result) {
    result = str
  }
  return result
}

function linkToAppStore() {
  if (IS_IOS) {
    window.location.href =
      'https://itunes.apple.com/app/apple-store/id994051627?pt=1667142&ct=m5&mt=8'
  } else {
    window.location.href = `https://m.xinli001.com/download`
  }
}

export async function handleCopy(el, params, cb, event) {
  try {
    const text = await getCommandRequest(params)
    setTimeout(() => {
      let clipboard = new Clipboard(el, {
        text: () => {
          return text
        }
      })

      clipboard.on('success', () => {
        typeof cb === 'function' && cb()
        clipboard.destroy()
        if (platform.isWechat) {
          linkToAppStore()
        } else {
          let delay = 2000
          if (IS_IOS) {
            // if (!IS_Safari) {
            //   // Safari 直接跳app store
            //   window.location.href = 'yixinli://open_home_page'
            // } else {
            //   console.log('safari')
            //   delay = 0
            // }
            window.location.href = 'yixinli://open_home_page'
          } else {
            window.location.href = `yixinli://open_main`
          }
          setTimeout(linkToAppStore, delay)
        }
      })
      clipboard.on('error', err => {
        console.log('copy error:' + err)
        typeof cb === 'function' && cb()
        clipboard.destroy()
        linkToAppStore()
      })
      event && clipboard.onClick(event)
    }, 100)
  } catch (e) {
    console.log(e)
    linkToAppStore()
  }
}

export function getCommandRequest({
  _platform = $platform,
  _version = '6.7.7',
  type = '',
  object_id = '',
  title = '',
  desc = '',
  url = ''
} = {}) {
  if (platform.isYixinliApp) return
  return new Promise((resolve, reject) => {
    const baseParams = {
      _platform: _platform,
      _version: _version,
      type: type,
      object_id: object_id,
      title: title,
      desc: desc,
      url: url
    }
    const platFormSign = getRequestSign(baseParams)
    const newParams = Object.assign(platFormSign.params, {
      sign: platFormSign.sign
    })
    axios
      .get(yiapiHost + `/v6/yi/common/create-encode-command.json`, {
        params: newParams
      })
      .then(res => {
        if (+res.data.code === 0) {
          resolve(res.data.data)
        } else {
          reject()
        }
      })
  })
}



// WEBPACK FOOTER //
// ./src/public-resource/libs/appCommand/command.js